// Клиент `/api/v1/healthz`.
//
// Форма ответа — `docs/spec/core/health.md`: единственное поле
// `status`, всегда равное `"serving"`. Других полей (времени, версии,
// имени узла, состояния зависимостей) проба сознательно не отдаёт.
//
// Типы вшиты руками параллельно с подключением `openapi-typescript`;
// при появлении генерации типов этот вручную написанный интерфейс
// заменится сгенерированным.
export interface HealthzResponse {
  readonly status: "serving";
}

export async function fetchHealthz(): Promise<HealthzResponse> {
  const response = await fetch("/api/v1/healthz", {
    headers: { Accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error(`healthz: HTTP ${String(response.status)}`);
  }
  return (await response.json()) as HealthzResponse;
}
